import { render, staticRenderFns } from "./AddPromotion.vue?vue&type=template&id=69656daa&scoped=true&"
import script from "./AddPromotion.vue?vue&type=script&lang=js&"
export * from "./AddPromotion.vue?vue&type=script&lang=js&"
import style0 from "./AddPromotion.vue?vue&type=style&index=0&id=69656daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69656daa",
  null
  
)

export default component.exports